import _isNil from "lodash/isNil";
import { getImageById } from "../images/selectors";
import { getCtaById } from "../ctas/selectors";
import { getPointById } from "../results/selectors";
import { getAudienceSegmentbyId } from "../audiences/selectors";

export function getPageById(entities, pageId) {
    const { pages } = entities;
    if (_isNil(pages)) {
        return null;
    }
    const page = pages[pageId];
    const ctas = page.ctas
        ? page.ctas.reduce((acc, ctaId) => {
              const cta = getCtaById(entities, ctaId);
              if (cta) {
                  acc.push(cta);
              }
              return acc;
          }, [])
        : [];
    return {
        ...page,
        ctas,
        image: getImageById(entities, page.image)
    };
}

export function getPageResultsByPageId(entities, pageId) {
    const { pageResults } = entities;
    if (_isNil(pageResults)) {
        return null;
    }
    const pageResult = pageResults[pageId];
    if (_isNil(pageResult)) {
        return null;
    }
    const { points, drivers, expectations, keyFindings } = pageResult;
    return {
        keyFindings,
        expectations,
        points: points.reduce((acc, pointId) => {
            const point = getPointById(entities, pointId);
            if (!_isNil(point)) {
                acc.push(point);
            }
            return acc;
        }, []),
        drivers: drivers.map(driver => {
            return {
                ...driver,
                quotes: driver.quotes.map(quote => {
                    return {
                        ...quote,
                        // TODO The Redux store only seems to have segments for Age and Gender in most cases. We're
                        // getting some quotes that are associated with Education segments now, which means that
                        // the segments array can contain undefined values. I took care of 1 place where that caused
                        // an issue, but there may be others. I'm going to log the misses and filter them out. Better
                        // solution is to make sure we get all of the segment data we need from the server.
                        // See https://trello.com/c/Xveek031
                        segments: quote.segmentIds
                            .map(id => {
                                const segment = getAudienceSegmentbyId(
                                    entities,
                                    id
                                );
                                if (!segment) {
                                    console.error(
                                        `Could not resolve audience segment for id ${id}`
                                    );
                                }
                                return segment;
                            })
                            .filter(Boolean)
                    };
                })
            };
        })
    };
}

export function sortPages(pages) {
    return pages.sort((a, b) => {
        const sortOrderComparison = a.sortOrder - b.sortOrder;
        if (sortOrderComparison !== 0) {
            return sortOrderComparison;
        }
        if (!a.isActive && !b.isActive) {
            return 0;
        }
        if (a.isActive && !b.isActive) {
            return -1;
        }
        if (!a.isActive && b.isActive) {
            return 1;
        }
        return a.name - b.name;
    });
}

export function getLabelForPage(pageIndex) {
    const pageLabels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return pageLabels.charAt(pageIndex);
}



// WEBPACK FOOTER //
// ./src/modules/pages/selectors.js